<template>
  <div>
    <cms-timeline
      v-if="timelineSetUp"
      :theme="timelineOptions"
      :timeline="homepage.timeline[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import isEmpty from 'lodash/isEmpty';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const homepage = computed(() => store.state.homepage);
const theme = computed(() => store.state.theme);
const isThemePreview = computed(() => store.state.isThemePreview);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const timelineOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: {
      ...store.getters['translation/getComponentTranslation']('spotlight'),
      ...store.getters['translation/getGlobalTranslations'],
    },
    globalThemeSettings: store.getters.getGlobalThemeSettings,
  };
});

const timelineSetUp = computed(() => !isEmpty(homepage.value?.timeline?.[id.value]?.items));
</script>
